import { makeStyles } from "@material-ui/core";
import { useReducer } from "react";
import { PrintRegister } from "../print-control/Print"
import CustomTabStyle from "../../componentes/tabs/CustomTabStyle";
import CustomTabs from "../../componentes/tabs/CustomTabs";
import SearchIcon from "@material-ui/icons/Search";
import { useTranslation } from "react-i18next";
import a11yProps from "../../componentes/tabs/a11Props";
import TabPanel from "../../componentes/tabs/TabPanel";
import FormContainer from "../../componentes/form-container/FormContainer";

/**
 * Author : AndréK
 * 26/08/2022
*/
const useStyles = makeStyles((theme) => ({
    root: {
        marginRight: 10,
    },
}));

const reducer = (state, data) => {
    return { ...state, ...data }
}

const initialState = {
    id: 0,
    tabValue: 0,
};

const PrintControl = () => {

    const { t } = useTranslation();
    const classes = useStyles();
    const [state, dispatch] = useReducer(reducer, initialState);
    const { id, tabValue } = state
    const handleTabChange = (event, newValue) => dispatch({ tabValue: newValue });

    return (
        <>
            <FormContainer>
                <CustomTabs
                    value={tabValue}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="print tab"
                >
                    <CustomTabStyle
                        label={t("printer")}
                        {...a11yProps(0)}
                        icon={<SearchIcon fontSize="small" classes={classes} />} />
                </CustomTabs>
                <TabPanel value={tabValue} index={0}>
                    <PrintRegister updateId={dispatch} />
                </TabPanel>
            </FormContainer>
        </>
    )
}

export default PrintControl;